<template>
    <div class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3">
        <div
            class="flex justify-between items-center cursor-pointer hover:bg-gray-50 p-4"
            @click="collapsed = !collapsed"
        >
            <div>
                ATF Accordion List ({{ atf_accordion_list.use_atf_accordion_list == 1 ? "active" : "inactive" }})
            </div>
            <div>
                <svg v-if="!collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
                <svg v-if="collapsed" class="h-4 w-4 cursor-pointer" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7" />
                </svg>
            </div>
        </div>
        <div v-show="collapsed">
            <Select
                label="Use ATF Accordion List?"
                name="use_atf_accordion_list"
                v-model="atf_accordion_list.use_atf_accordion_list"
                :options="[
                    { value: 1, name: 'Yes' },
                    { value: 0, name: 'No' },
                ]"
                :error="errors['atf_accordion_list.use_atf_accordion_list'] ? errors['atf_accordion_list.use_atf_accordion_list'][0] : null"
            />

            <input-text
                :label="atf_accordion_list.use_atf_accordion_list == 1 ? '* Heading' : 'Heading'"
                name="heading"
                v-model="atf_accordion_list.heading"
                class="mt-3"
                :maxlength="255"
                :error="errors['atf_accordion_list.heading'] ? errors['atf_accordion_list.heading'][0] : null"
            />
            <p class="text-xs text-gray-600">
                You can use these available shortcodes in the heading field
                above: [current_year], [current_month] and [current_abrev_month]
            </p>

            <input-rich-text
                name="content"
                label="Content"
                v-model="atf_accordion_list.content"
                class="mt-2"
                :language="language"
                :error="errors['atf_accordion_list.content'] ? errors['atf_accordion_list.content'][0] : null"
                :maxlength="60000"
            />

            <atf-accordion-list-items
                class="mt-3"
                v-model="atf_accordion_list.items"
                :language="language"
                :errors="errors"
            />

        </div>
    </div>
</template>

<script>

export default {
    name: "AtfAccordionList",
    props: {
        value: {
            type: Object,
            required: true,
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            },
        },
    },
    data() {
        return {
            atf_accordion_list: this.value,
            collapsed: 0,
        };
    },
};
</script>
